module.exports = __webpack_public_path__ + "static/media/user_security.7db589d3.svg";